var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.243,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56 0h2.197a.41.41 0 0 1 .41.41 2.668 2.668 0 0 0 2.666 2.665.41.41 0 0 1 .41.41v2.197a.41.41 0 0 1-.41.41c-.94 0-1.85-.227-2.666-.662v3.986A4.589 4.589 0 0 1 4.584 14 4.589 4.589 0 0 1 0 9.416a4.589 4.589 0 0 1 4.584-4.583.41.41 0 0 1 .41.41v2.196a.41.41 0 0 1-.41.41c-.864 0-1.567.703-1.567 1.567s.703 1.567 1.567 1.567S6.15 10.28 6.15 9.416V.41A.41.41 0 0 1 6.56 0Zm1.811.82h-1.4v8.596a2.39 2.39 0 0 1-2.387 2.387 2.39 2.39 0 0 1-2.387-2.387 2.39 2.39 0 0 1 1.977-2.352V5.675A3.769 3.769 0 0 0 .82 9.416a3.768 3.768 0 0 0 3.764 3.764 3.768 3.768 0 0 0 3.763-3.764V4.692a.41.41 0 0 1 .65-.333 4.82 4.82 0 0 0 2.425.896V3.872A3.493 3.493 0 0 1 8.372.82Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "path1950"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.9d61e36f594440f5789d5eb2c3459691.svg";
export { ForwardRef as ReactComponent };